export default __webpack_public_path__ + "static/media/border-cap-butt-17.bc0e1ae0.svg";